import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ToastWrapperComponent } from './toast-wrapper/toast-wrapper.component';
import { ToastsContainerComponent } from './toasts-container/toasts-container.component';
import { WarningToastComponent } from './warning-toast/warning-toast.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  declarations: [ToastWrapperComponent, ToastsContainerComponent, WarningToastComponent],
  exports: [ToastWrapperComponent, ToastsContainerComponent, WarningToastComponent]
})
export class ToastsModule {}
